<template>
  <div class="big">
    <div class="page_title flex_between">
      <span>{{ pageTitle }}</span>
      <el-button type="primary" style="width: 92px" @click="back" size="medium"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container" style="padding: 10px 20px 20px 20px">
        <el-form
          :model="diagnosisCouponForm"
          :rules="rules"
          ref="diagnosisCouponRef"
          label-width="110px"
          class="diagnosisCoupon-ruleForm"
          :disabled="isLook"
        >
          <el-form-item label="优惠券名称" prop="coupon_name">
            <el-input
              v-model="diagnosisCouponForm.coupon_name"
              size="small"
              clearable
              maxlength="10"
              placeholder="请输入"
            ></el-input>
          </el-form-item>

          <el-form-item label="排序" prop="sort">
            <el-input-number
              v-model="diagnosisCouponForm.sort"
              size="small"
              :min="0"
              :max="999999999"
              :precision="0"
              :controls="false"
            ></el-input-number>
            <span class="prompt"
              >数字越大，排名越靠前,如果为空，默认排序方式为创建时间</span
            >
          </el-form-item>

          <el-form-item
            label="使用时间"
            prop="time_limit"
            class="radio-group-box"
          >
            <el-radio-group
              v-model="diagnosisCouponForm.time_limit"
              @input="timeLimitChange"
              :disabled="isEdit"
              style="padding-top: 6px"
            >
              <el-radio :label="2">
                <span class="sub_title">时间范围</span>
                <el-date-picker
                  v-model="diagnosisCouponForm.time"
                  :disabled="diagnosisCouponForm.time_limit != 2 || isEdit"
                  type="daterange"
                  size="small"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  @change="validateChange('time_limit')"
                />
              </el-radio>
              <el-radio :label="1">
                <span class="sub_title">获取后</span>
                <el-input-number
                  v-model="diagnosisCouponForm.time_days"
                  :disabled="diagnosisCouponForm.time_limit != 1 || isEdit"
                  size="small"
                  :min="1"
                  :max="999999999"
                  :precision="0"
                  :controls="false"
                  @blur="validateChange('time_limit')"
                ></el-input-number>
                <span>&nbsp;天有效</span>
              </el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="领取时间" prop="show_time">
            <el-date-picker
              v-model="diagnosisCouponForm.show_time"
              type="daterange"
              size="small"
              :disabled="isEdit"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item
            label="使用门槛"
            prop="moneyType"
            class="radio-group-box"
          >
            <el-radio-group
              v-model="diagnosisCouponForm.moneyType"
              @input="moneyTypeChange"
              :disabled="isEdit"
              style="padding-top: 8px"
            >
              <el-radio :label="1">无门槛</el-radio>
              <el-radio :label="2">
                <span class="sub_title">满</span>
                <el-input-number
                  v-model="diagnosisCouponForm.money"
                  :disabled="diagnosisCouponForm.moneyType != 2 || isEdit"
                  size="small"
                  :min="0.01"
                  :max="999999999"
                  :precision="2"
                  :controls="false"
                  @blur="validateChange('moneyType')"
                ></el-input-number>
                <span>&nbsp;元</span>
              </el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            label="优惠券类型"
            class="radio-group-box coupon-type"
            prop="coupon_type"
          >
            <el-radio-group
              v-model="diagnosisCouponForm.coupon_type"
              :disabled="isEdit"
              style="padding-top: 4px"
              @change="couponTypeChange"
            >
              <el-radio :label="1">
                <span class="sub_title">药品减免券&nbsp;药品费减&nbsp;</span>
                <el-input-number
                  v-model="diagnosisCouponForm.enough1"
                  :disabled="diagnosisCouponForm.coupon_type != 1 || isEdit"
                  size="small"
                  :min="0.01"
                  :max="999999999"
                  :precision="2"
                  :controls="false"
                  @blur="validateChange('coupon_type')"
                ></el-input-number>
                <span>&nbsp;元</span>
                <span class="prompt">可减免药品金额、诊后管理费、诊金</span>
              </el-radio>
              <el-radio :label="3">
                <span class="sub_title">问诊减免券&nbsp;问诊费减&nbsp;</span>
                <el-input-number
                  v-model="diagnosisCouponForm.enough3"
                  :disabled="diagnosisCouponForm.coupon_type != 3 || isEdit"
                  size="small"
                  :min="0.01"
                  :max="999999999"
                  :precision="2"
                  :controls="false"
                  @blur="validateChange('coupon_type')"
                ></el-input-number>
                <span>&nbsp;元</span>
                <span class="prompt"
                  >可减免图文问诊、视频问诊、电话问诊问诊费</span
                >
              </el-radio>
              <el-radio :label="4">
                <span class="sub_title">问诊折扣券&nbsp;问诊费打&nbsp;</span>
                <el-input-number
                  v-model="diagnosisCouponForm.enough4"
                  :disabled="diagnosisCouponForm.coupon_type != 4 || isEdit"
                  size="small"
                  :min="0.1"
                  :max="9.9"
                  :precision="1"
                  :controls="false"
                  @blur="validateChange('coupon_type')"
                ></el-input-number>
                <span>&nbsp;折扣,最多可优惠&nbsp;</span>
                <el-input-number
                  v-model="diagnosisCouponForm.max_price"
                  :disabled="diagnosisCouponForm.coupon_type != 4 || isEdit"
                  size="small"
                  :min="0.1"
                  :max="999999999.9"
                  :precision="1"
                  :controls="false"
                  @blur="validateChange('coupon_type')"
                ></el-input-number>
                <span>&nbsp;元</span>
                <span class="prompt"
                  >不输入时则无优惠上限，可减免图文问诊、视频问诊、电话问诊问诊费</span
                >
              </el-radio>
              <el-radio :label="5"
                >运费全减券
                <span class="prompt"
                  >订单金额满足门槛时可减免整个订单的运费</span
                ></el-radio
              >
              <el-radio :label="6">
                <span class="sub_title">VIP陪诊券&nbsp;VIP陪诊减&nbsp;</span>
                <el-input-number
                  v-model="diagnosisCouponForm.enough6"
                  :disabled="diagnosisCouponForm.coupon_type != 6 || isEdit"
                  size="small"
                  :min="0.01"
                  :max="999999999"
                  :precision="2"
                  :controls="false"
                  @blur="validateChange('coupon_type')"
                ></el-input-number>
                <span>&nbsp;元</span>
                <span class="prompt">可减免VIP陪诊费</span>
              </el-radio>
              <el-radio :label="7">
                <span class="sub_title"
                  >养生卡权益券&nbsp;购买养生卡减&nbsp;</span
                >
                <el-input-number
                  v-model="diagnosisCouponForm.enough7"
                  :disabled="diagnosisCouponForm.coupon_type != 7 || isEdit"
                  size="small"
                  :min="0.01"
                  :max="999999999"
                  :precision="2"
                  :controls="false"
                  @blur="validateChange('coupon_type')"
                ></el-input-number>
                <span>&nbsp;元</span>
                <span class="prompt">可减免购买养生卡费用</span>
              </el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            :label="`${isEdit ? '剩余发放总数' : '发放总数'}`"
            prop="total"
          >
            <el-input-number
              v-model="diagnosisCouponForm.total"
              size="small"
              :min="-1"
              :max="999999999"
              :precision="0"
              :controls="false"
            ></el-input-number>
            <!-- @blur="changeTotal"></el-input-number> -->
            <span class="prompt"
              >优惠券总数量，为空时不能领取或发放,-1 为不限制张数</span
            >
          </el-form-item>

          <el-form-item label="领取上限" prop="max_get_num">
            <el-input-number
              v-model="diagnosisCouponForm.max_get_num"
              size="small"
              :min="0"
              :max="999999999"
              :precision="0"
              :controls="false"
            ></el-input-number>
            <span>&nbsp;张</span>
            <span class="prompt"
              >仅当用户自己领取/兑换时，限制的领取数量，自动发放不影响 0为不限制
            </span>
          </el-form-item>

          <el-form-item label="退还方式" prop="return_type">
            <el-radio-group
              v-model="diagnosisCouponForm.return_type"
              :disabled="isEdit"
              style="padding-top: 4px"
            >
              <el-radio :label="1">不退还</el-radio>
              <el-radio :label="2"
                >退还&nbsp;<span class="prompt"
                  >若为药品券仅当处方作废时退还</span
                ></el-radio
              >
            </el-radio-group>
          </el-form-item>

          <el-form-item label="到期提醒" prop="is_notice">
            <el-radio-group
              v-model="diagnosisCouponForm.is_notice"
              @input="isNoticeChange"
              :disabled="isEdit"
              style="padding-top: 4px"
            >
              <el-radio :label="0">不提醒</el-radio>
              <el-radio :label="1">
                <span class="sub_title">到期前</span>
                <el-input-number
                  v-model="diagnosisCouponForm.notice_day"
                  :disabled="diagnosisCouponForm.is_notice != 1 || isEdit"
                  size="small"
                  :min="1"
                  :max="999999999"
                  :precision="0"
                  :controls="false"
                  @change="validateChange('is_notice')"
                ></el-input-number>
                <span>&nbsp;天提醒</span>
              </el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="是否可分享" prop="is_share">
            <el-radio-group
              v-model="diagnosisCouponForm.is_share"
              style="padding-top: 4px"
            >
              <el-radio :label="0">不可分享</el-radio>
              <el-radio :label="1">可分享</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="使用端口" prop="is_share">
            <el-radio-group
              v-model="diagnosisCouponForm.use_from"
              style="padding-top: 4px"
            >
              <el-radio :label="0">不限端口</el-radio>
              <el-radio :label="1">仅小程序使用</el-radio>
              <el-radio :label="2">仅app使用</el-radio>
            </el-radio-group>
          </el-form-item>

          <template
            v-if="
              diagnosisCouponForm.coupon_type != 6 &&
              diagnosisCouponForm.coupon_type != 7
            "
          >
            <el-form-item
              v-if="
                diagnosisCouponForm.coupon_type == 1 ||
                diagnosisCouponForm.coupon_type == 5
              "
              label="适用范围"
              prop="range"
            >
              <el-checkbox-group
                v-model="diagnosisCouponForm.range"
                style="padding-top: 6px"
                @change="$forceUpdate()"
              >
                <el-checkbox label="1" name="range">颗粒</el-checkbox>
                <el-checkbox label="2" name="range">饮片</el-checkbox>
                <el-checkbox label="3" name="range">膏方</el-checkbox>
                <el-checkbox label="4" name="range">丸剂</el-checkbox>
                <el-checkbox label="5" name="range">粉剂</el-checkbox>
                <el-checkbox label="6" name="range">胶囊</el-checkbox>
                <el-checkbox label="-1" name="range">成药</el-checkbox>
                <el-checkbox label="0" name="range">养生方</el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item v-else label="适用范围" prop="range">
              <el-radio-group
                v-model="diagnosisCouponForm.open_doctor"
                style="padding-top: 4px"
              >
                <el-radio :label="0">全部医生</el-radio>
                <el-radio :label="1">部分医生</el-radio>
              </el-radio-group>
            </el-form-item>
          </template>

          <div
            v-if="diagnosisCouponForm.open_doctor == 1"
            class="seclect-doctor"
          >
            <div class="flex">
              <el-button
                type="primary"
                size="small"
                @click="recommendDoctorTableDia = true"
                >选择医生</el-button
              >
              <el-button
                type="primary"
                size="small"
                @click="batchImportBtn"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1725') : false
                "
                >批量导入</el-button
              >
            </div>
            <el-table
              :data="seclectDoctorData"
              border
              max-height="500px"
              style="width: 1200px; margin: 10px 0"
            >
              <el-table-column prop="doctor_name" label="医生姓名" width="180">
              </el-table-column>
              <el-table-column prop="phone" label="医生手机号" width="180">
              </el-table-column>
              <el-table-column prop="hospital" label="医生所在医院">
              </el-table-column>
              <el-table-column prop="title" label="医生职称" width="180">
              </el-table-column>
              <el-table-column prop="department_name" label="科室" width="180">
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="delDoctor(scope.$index)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>

          <el-form-item class="btn-box">
            <el-button @click="back">取 消</el-button>
            <el-button type="primary" @click="saveBtn('diagnosisCouponRef')"
              >确 定</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 选择医生弹框 -->
    <choose-doctor
      :recommendDoctorTableDia.sync="recommendDoctorTableDia"
      @confirmDoctor="confirmDoctor"
    ></choose-doctor>
    <!-- 批量导入医生 -->
    <el-dialog title="导入" :visible.sync="dialogPhone" width="30%" center>
      <div class="content" style="padding: 10px; height: 180px">
        <el-form :model="dialogPhoneForm" label-width="100px">
          <el-form-item label="医生手机号：">
            <el-input
              v-model="dialogPhoneForm.doctor_phone"
              type="textarea"
              :rows="8"
              placeholder="请填写指定医生手机号，多个用英文逗号隔开"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogPhone = false">取 消</el-button>
        <el-button type="primary" size="small" @click="batchImportConfirmBtn"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import common from "@/api/common.js";
import marketing from "@/api/marketing.js";
import ChooseDoctor from "@/components/chooseDoctor/index";
export default {
  components: {
    ChooseDoctor,
  },
  data() {
    const validateTime = (rule, value, callback) => {
      if (value == 2 && !this.diagnosisCouponForm.time) {
        callback(new Error("请选择时间"));
      } else if (value == 1 && !this.diagnosisCouponForm.time_days) {
        callback(new Error("请输入天数"));
      } else {
        callback();
      }
    };
    const validateMoneyType = (rule, value, callback) => {
      if (value == 2 && !this.diagnosisCouponForm.money) {
        callback(new Error("请输入金额"));
      } else {
        callback();
      }
    };
    const validateCouponType = (rule, value, callback) => {
      if (!this.diagnosisCouponForm.enough1 && value == 1) {
        callback(new Error("请输入金额"));
      } else if (!this.diagnosisCouponForm.enough3 && value == 3) {
        callback(new Error("请输入金额"));
      } else if (!this.diagnosisCouponForm.enough4 && value == 4) {
        callback(new Error("请输入折扣和金额"));
      } else if (!this.diagnosisCouponForm.enough6 && value == 6) {
        callback(new Error("请输入金额"));
      } else if (!this.diagnosisCouponForm.enough7 && value == 7) {
        callback(new Error("请输入金额"));
      } else {
        callback();
      }
    };
    const validateIsNotice = (rule, value, callback) => {
      if (value == 1 && !this.diagnosisCouponForm.notice_day) {
        callback(new Error("请输入天数"));
      } else {
        callback();
      }
    };

    return {
      diagnosisCouponForm: {
        coupon_name: "",
        sort: undefined,
        time_limit: 2, // 使用时间
        time: "",
        time_days: undefined,
        show_time: "", // 领取时间
        moneyType: 1, // 使用门槛
        money: undefined,
        coupon_type: 1, // 优惠券类型
        enough1: undefined,
        enough3: undefined,
        enough4: undefined,
        enough6: undefined,
        enough7: undefined,
        max_price: undefined,
        total: undefined,
        max_get_num: undefined,
        return_type: 1, // 退还方式
        is_notice: 0, // 到期提醒
        notice_day: undefined,
        range: ["-1", "0", "1"],
        is_share: 0,
        use_from: 0,
        open_doctor: 0,
        doctor_id: "",
      },
      rules: {
        coupon_name: [{ required: true, message: "请输入", trigger: "blur" }],
        time_limit: [
          { required: true, validator: validateTime, trigger: "change" },
        ],
        moneyType: [
          { required: true, validator: validateMoneyType, trigger: "change" },
        ],
        coupon_type: [
          { required: true, validator: validateCouponType, trigger: "blur" },
        ],
        return_type: [{ required: true, message: "请选择", trigger: "change" }],
        is_notice: [
          { required: true, validator: validateIsNotice, trigger: "change" },
        ],
        range: [{ required: true, message: "请选择", trigger: "change" }],
        is_share: [{ required: true, message: "请选择", trigger: "change" }],
        use_from: [{ required: true, message: "请选择", trigger: "change" }],
      },
      oldTotal: 1,
      seclectDoctorData: [],
      recommendDoctorTableDia: false,
      dialogPhone: false,
      dialogPhoneForm: {
        doctor_phone: "",
      },
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD");
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    routeQuery() {
      return this.$route.query;
    },
    pageTitle() {
      let type = Number(this.$route.query.type);
      switch (type) {
        case 1:
          return "添加优惠券";
        case 2:
          return "优惠券详情";
        case 3:
          return "编辑优惠券";
      }
    },
    isLook() {
      return this.$route.query.type == 2;
    },
    isEdit() {
      return this.$route.query.type == 3;
    },
  },
  created() {
    if (this.routeQuery.type != 1) {
      this.getCouponInfo();
    }
  },
  methods: {
    // 优惠券类型切换
    couponTypeChange(val) {
      switch (val) {
        case 1:
          this.diagnosisCouponForm.range = ["-1", "0", "1"];
          break;
        case 5:
          this.diagnosisCouponForm.range = [];
          break;
        default:
          this.diagnosisCouponForm.range = ["-1", "0", "1"];
          break;
      }
      this.$nextTick(() => {
        this.$refs["diagnosisCouponRef"].clearValidate("range");
      });
    },
    getCouponInfo() {
      const loading = this.$loading();
      let params = {
        coupon_data_id: this.routeQuery.coupon_data_id,
      };
      marketing
        .getCouponInfo(params)
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            this.oldTotal = data.info.total;
            this.diagnosisCouponForm = _.omit(
              Object.assign({}, this.diagnosisCouponForm, data.info),
              [
                "time_start",
                "time_end",
                "show_start_time",
                "show_end_time",
                "range",
                "doctor",
                "enough",
              ]
            );

            if (data.info.time_limit == 2) {
              let time_start = dayjs
                .unix(data.info.time_start)
                .format("YYYY-MM-DD");
              let time_end = dayjs
                .unix(data.info.time_end)
                .format("YYYY-MM-DD");
              this.diagnosisCouponForm.time = [time_start, time_end];
            }
            let show_start_time = !data.info.show_start_time
              ? ""
              : dayjs.unix(data.info.show_start_time).format("YYYY-MM-DD");
            let show_end_time = !data.info.show_end_time
              ? ""
              : dayjs.unix(data.info.show_end_time).format("YYYY-MM-DD");
            this.diagnosisCouponForm.show_time = [
              show_start_time,
              show_end_time,
            ];
            this.diagnosisCouponForm.range = data.info.range.split(",");
            this.diagnosisCouponForm.time_days = !data.info.time_days
              ? undefined
              : data.info.time_days;
            this.diagnosisCouponForm.money = !Number(data.info.money)
              ? undefined
              : data.info.money;
            this.diagnosisCouponForm.moneyType = !Number(data.info.money)
              ? 1
              : 2;
            console.log(this.diagnosisCouponForm);
            switch (this.diagnosisCouponForm.coupon_type) {
              case 1:
                this.diagnosisCouponForm.enough1 = data.info.enough;
                break;
              case 3:
                this.diagnosisCouponForm.enough3 = data.info.enough;
                break;
              case 4:
                this.diagnosisCouponForm.enough4 = data.info.enough;
                break;
              case 6:
                this.diagnosisCouponForm.enough6 = data.info.enough;
                break;
              case 7:
                this.diagnosisCouponForm.enough7 = data.info.enough;
                break;
            }
            this.seclectDoctorData = data.info.doctor;
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    // 改变时间
    timeLimitChange(val) {
      this.diagnosisCouponForm.time_days = val == 2 ? undefined : 1;
      this.diagnosisCouponForm.time = "";
      this.$nextTick(() =>
        this.$refs["diagnosisCouponRef"].clearValidate("time_limit")
      );
    },
    // 改变使用门槛
    moneyTypeChange(val) {
      this.diagnosisCouponForm.money = val == 1 ? undefined : 1;
      this.$nextTick(() =>
        this.$refs["diagnosisCouponRef"].clearValidate(" money_type")
      );
    },
    // 发放总数
    // changeTotal() {
    // if (this.isEdit) {
    //   let { total } = this.diagnosisCouponForm;
    //   if (total < this.oldTotal && total != -1) {
    //     this.$message.warning('编辑时，发放总数只能改大或改为-1');
    //     this.diagnosisCouponForm.total = this.oldTotal;
    //   }
    // }
    // },
    // 改变到期提醒
    isNoticeChange(val) {
      this.diagnosisCouponForm.notice_day = !val ? undefined : 1;
      this.$nextTick(() =>
        this.$refs["diagnosisCouponRef"].clearValidate("is_notice")
      );
    },
    saveBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading();
          let params = _.omit(this.diagnosisCouponForm, [
            "time",
            "show_time",
            "moneyType",
            "enough1",
            "enough3",
            "enough4",
            "enough6",
            "enough7",
          ]);
          let {
            time,
            show_time,
            moneyType,
            enough1,
            enough3,
            enough4,
            enough6,
            enough7,
            coupon_type,
          } = this.diagnosisCouponForm;
          params.enough =
            coupon_type == 1
              ? enough1
              : coupon_type == 3
              ? enough3
              : coupon_type == 4
              ? enough4
              : coupon_type == 6
              ? enough6
              : enough7;
          params.time_start = !time ? "" : time[0];
          params.time_end = !time ? "" : time[1];
          params.show_start_time = !show_time ? "" : show_time[0];
          params.show_end_time = !show_time ? "" : show_time[1];
          params.money = moneyType == 1 ? 0 : params.money;
          params.range = params.range.join();
          params.doctor_id = this.seclectDoctorData
            .map((item) => item.doctor_id)
            .join(",");
          let interfaceName =
            this.routeQuery.type == 1 ? "createCoupon" : "editCoupon";
          if (this.routeQuery.type != 1) {
            params.coupon_data_id = this.routeQuery.coupon_data_id;
          }
          marketing[interfaceName](params)
            .then((res) => {
              let { code } = res;
              if (code === 0) {
                this.$message.success("保存成功");
                this.back();
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 验证
    validateChange(propName) {
      this.$nextTick(() =>
        this.$refs["diagnosisCouponRef"].validateField([propName])
      );
    },
    // 选择医生
    confirmDoctor(data) {
      let doctor_arr = data.map((item) => {
        let obj = _.pick(item, [
          "doctor_id",
          "doctor_name",
          "phone",
          "department_name",
          "hospital",
          "title",
        ]);
        return obj;
      });
      let arr = _.uniqBy(
        [...doctor_arr, ...this.seclectDoctorData],
        "doctor_id"
      );
      this.seclectDoctorData = arr;
    },
    // 删除医生
    delDoctor(index) {
      this.seclectDoctorData.splice(index, 1);
    },
    // 批量导入
    batchImportBtn() {
      this.dialogPhoneForm.doctor_phone = "";
      this.dialogPhone = true;
    },
    batchImportConfirmBtn() {
      let { doctor_phone } = this.dialogPhoneForm;
      let params = {
        phone: doctor_phone,
      };
      common.getPhoneAllDoctor(params).then((res) => {
        let { code, data } = res;
        if (code === 0) {
          let { list, error_count } = data;
          if (!error_count) {
            this.confirmDoctor(list);
            this.$message.success("导入成功");
            this.dialogPhone = false;
            return;
          }
          this.$confirm(`存在${error_count}条错误数据未导入成功`, "提示", {
            confirmButtonText: "知道了",
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            showCancelButton: false,
          })
            .then(() => {
              this.confirmDoctor(list);
              this.dialogPhone = false;
            })
            .catch(() => {
              this.confirmDoctor(list);
              this.dialogPhone = false;
            });
        }
      });
    },
    back() {
      history.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.diagnosisCoupon-ruleForm {
  .el-form-item {
    display: flex;
    align-items: center;
    ::v-deep .el-form-item__content {
      margin-left: 0 !important;
      display: flex;
      align-items: center;
      .sub_title {
        display: inline-block;
        min-width: 80px;
        text-align: left;
      }
    }
  }
  .radio-group-box {
    align-items: flex-start;

    ::v-deep.el-form-item__content {
      height: 76px;
    }
    .el-radio-group {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .el-radio:first-child {
        margin-bottom: 10px;
      }
    }
  }
  .coupon-type {
    ::v-deep .el-form-item__content {
      height: auto;
    }
    .el-radio {
      margin-bottom: 10px;
    }
  }
  .btn-box {
    padding-left: 200px;
  }
  .seclect-doctor {
    max-height: 500px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-left: 30px;
  }
}
</style>
